export const VERCEL_URL = 'https://kinklist-v2.vercel.app';